import { useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { extractUtmFromSearch, setCurrentPageUtm } from '@utils/utmTracking';

export function useGlobalUtm() {
  const { pathname, search, hash } = useLocation();
  const navigate = useNavigate();
  const prevRouteKeyRef = useRef<string>('');

  useEffect(() => {
    const { utmParams, cleanedSearch, hasUtmParamsInSearch } = extractUtmFromSearch(search);
    const routeKey = `${pathname}?${cleanedSearch}`;
    const routeChanged = prevRouteKeyRef.current !== routeKey;

    if (hasUtmParamsInSearch) {
      setCurrentPageUtm(utmParams);
    } else if (routeChanged) {
      setCurrentPageUtm({});
    }

    prevRouteKeyRef.current = routeKey;

    if (!hasUtmParamsInSearch) return;

    const nextSearch = cleanedSearch ? `?${cleanedSearch}` : '';
    if (nextSearch === search) return;

    navigate({ pathname, search: nextSearch, hash }, { replace: true });
  }, [hash, navigate, pathname, search]);
}
